import { Box, BoxProps } from '@spark-web/box';
import { SparkThemeName } from '@spark-web/theme';
import { forwardRef } from 'react';

type PromoTagProps = BoxProps & {
  theme?: SparkThemeName;
};

const PromoTag = forwardRef<HTMLDivElement, PromoTagProps>(({ theme, ...props }, ref) => {
  if (theme !== 'pantheon') {
    throw new Error('PromoTag component is only available in Pantheon theme');
  }

  return (
    <Box
      ref={ref}
      background="primary"
      paddingX="medium"
      paddingY="small"
      borderRadius="full"
      css={{
        background: 'linear-gradient(90deg, #FFCC01, #FFF991)',
      }}
      {...props}
    />
  );
});

PromoTag.displayName = 'PromoTag';

export default PromoTag;
